import { Route, Routes } from 'react-router-dom'

import { OverviewPage, LanguagePage } from '~/modules/profile/view'

export const PATH = {
  OVERVIEW: '/',
  LANGUAGE: 'language',
}

export const ProfileRoutes = () => (
  <Routes>
    <Route index element={<OverviewPage />} />
    <Route path={PATH.LANGUAGE} element={<LanguagePage />} />
  </Routes>
)

export const profileLinks = {
  profileOverviewLink: () => PATH.OVERVIEW,
  languageLink: () => `/${PATH.LANGUAGE}`,
}
